import React from 'react';
import css from './SetupPage.module.scss';
import {Step} from './step/Step';
import {GetStartedSection} from './get-started/GetStartedSection';
import {HeartRateMonitorsSection} from './heart-rate-monitors/HeartRateMonitorsSection';
import {BroPlanSection} from './bro-plan/BroPlanSection';
import {ConfigureWidgetsSection} from './configure-widgets/ConfigureWidgetsSection';
import {MobileAppSection} from './mobile-app/MobileAppSection';
import {GoLiveSection} from './go-live/GoLiveSection';
import {useEffect} from 'react';
import {useLocation} from 'react-router';
import {useScrollService} from './ScrollService';
import {getPulsoidSetupConfiguration} from '../../setupSteps/getPulsoidSetupConfiguration';
import {
  SETUP_STEPS_ARRAY,
  SETUP_STEP_TYPES,
} from '../../setupSteps/SetupStepTypes';

export const Setup: React.FC<{}> = () => {
  const [checkedSteps, setCheckedSteps] = React.useState<Set<SETUP_STEP_TYPES>>(
    new Set<SETUP_STEP_TYPES>()
  );
  const location = useLocation();
  let scroller = useScrollService();

  useEffect(() => {
    if (!location.search && location.pathname.includes('thank-you')) {
      scroller.current.scroll('get-started');
    }
  }, [location]);

  function scrollToFirstUncheckedStep(
    checkedSteps: Set<SETUP_STEP_TYPES>,
    scroller: any
  ) {
    if (checkedSteps.size !== 6) {
      for (const step of SETUP_STEPS_ARRAY) {
        if (!checkedSteps.has(step)) {
          scroller.current.scroll(step);
          break;
        }
      }
    } else {
      scroller.current.scroll('bro-plan');
    }
  }

  useEffect(() => {
    async function fetchSetupConfiguration() {
      const setupConfig = await getPulsoidSetupConfiguration();
      setCheckedSteps(setupConfig.completedSteps);
    }
    fetchSetupConfiguration();
  }, []);

  useEffect(() => {
    if (
      location.pathname.includes('welcome') &&
      !location.search &&
      checkedSteps.size > 0
    ) {
      scrollToFirstUncheckedStep(checkedSteps, scroller);
    }
  }, [checkedSteps]);

  return (
    <div className={css.root}>
      <div className={css.header}>
        <h1>Setup Pulsoid</h1>
      </div>
      <div className={css.content}>
        <div className={css.sections_flex}>
          <div className={css.steps_list_section}>
            <Step
              title="Get started"
              isChecked={checkedSteps.has('get-started')}
              type="get-started"
            ></Step>
            <Step
              title="Get a heart rate monitor"
              isChecked={checkedSteps.has('heart-rate-monitors')}
              type="heart-rate-monitors"
            ></Step>
            <Step
              title="Install mobile app"
              isChecked={checkedSteps.has('mobile-app')}
              type="mobile-app"
            ></Step>
            <Step
              title="Configure widgets"
              isChecked={checkedSteps.has('configure-widgets')}
              type="configure-widgets"
            ></Step>
            <Step
              title="Go Live"
              isChecked={checkedSteps.has('go-live')}
              type="go-live"
            ></Step>
            <Step
              title="Upgrade to Pulsoid BRO"
              isChecked={checkedSteps.has('bro-plan')}
              type="bro-plan"
              isBro={true}
            ></Step>
          </div>
          <GetStartedSection type="get-started" />
          <HeartRateMonitorsSection type="heart-rate-monitors" />
          <MobileAppSection type="mobile-app" />
          <ConfigureWidgetsSection type="configure-widgets" />
          <GoLiveSection type="go-live" />
          <BroPlanSection type="bro-plan" />
        </div>
      </div>
    </div>
  );
};
